namespace appn.views.docDefinitions.createOrEdit {
    export function init(): void {
        appn.select.init({
            selector: 'select#iconsToDisplay',
            isIconSelect: true
        });
    }
}
